import { axiosApi } from "../../../../../api/dbAxios";
import { INewPrompt } from "../interfaces/prompt.interface";

export const createPromptLibrary = async (prompt: INewPrompt) => {
  try {
    const response = await axiosApi.post(`/prompts/`, prompt);
    return response.data;
  } catch (error: any) {
    const respData = error?.response?.data;
    const message =
      respData?.team_id?.[0] ?? respData?.detail ??
      (typeof respData === "string" ? respData : undefined) ??
      error?.message ?? String(error);
    throw message;
  }
};
